import { createFileRoute } from "@tanstack/react-router";

import { useEstimate, useEstimates } from "@/braining/store";
import { EstimateWizard } from "@/braining/components/estimate-wizard";

export const Route = createFileRoute("/estimates/$id")({ component: EstimatePage });

function EstimatePage() {
  const { id } = Route.useParams();
  const { ready } = useEstimates();
  const view = useEstimate(id);

  if (!ready) return <p className="text-sm text-muted-foreground">Загружаем…</p>;
  if (!view) {
    return (
      <p className="text-sm text-muted-foreground">
        Смета не найдена — возможно, её удалили в этом браузере.
      </p>
    );
  }

  return <EstimateWizard view={view} />;
}
